export default __webpack_public_path__ + "static/img1-d335a427153fa0127936158773daaa9f.png";